import React from "react";
import { fabric } from "fabric";
import ImageFilter from "react-image-filter";
import { Arrows } from "./Extras.jsx";
import { subscribe } from "./pubsubEngine";

const deleteIcon =
  '<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg width="100%" height="100%" viewBox="0 0 46 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"><path d="M29.652,2.536c-1.414,0 -2.56,-1.136 -2.56,-2.536l-8.346,0c0,1.4 -1.146,2.536 -2.56,2.536l-11.266,0l0,2.584l36.16,0l0,-2.584l-11.428,0Zm-17.008,33.312l20.712,0l5.17,-28.168l-31.052,0l5.17,28.168Zm17.13,-23.696c0,-0.83 0.68,-1.504 1.52,-1.504c0.84,0 1.52,0.674 1.52,1.504l-2.24,19.068c0,0.832 -0.68,1.506 -1.52,1.506c-0.836,0 -1.516,-0.674 -1.516,-1.506l2.234,-19.068l0.002,0Zm-8.27,0c0,-0.83 0.68,-1.504 1.52,-1.504c0.84,0 1.52,0.674 1.52,1.504l0,19.068c0,0.832 -0.68,1.506 -1.52,1.506c-0.84,0 -1.52,-0.674 -1.52,-1.506l0,-19.068Zm-7.2,-1.504c0.84,0 1.52,0.674 1.52,1.504l2.6,19.068c0,0.832 -0.68,1.506 -1.52,1.506c-0.84,0 -1.52,-0.674 -1.52,-1.506l-2.6,-19.068c0,-0.83 0.68,-1.504 1.52,-1.504Z" style="fill:#818a9c;fill-rule:nonzero;"/></svg>';
const textString =
  '<?xml version="1.0" encoding="UTF-8" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg width="100%" height="100%" viewBox="0 0 32 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-miterlimit:10;"><path d="M1,0.4l30,0l0.4,9l-1.4,0c-0.6,-2.8 -1.4,-4.6 -2.4,-5.6c-0.8,-1.6 -2.8,-2 -6,-2l-2.8,0l0,28c0,2 0,2.8 0.8,3.4c0.8,0.6 2,0.8 4.4,1l0,1l-15.6,0l0,-1c2,0 3.6,-0.6 4,-1.2c0.6,-0.4 1,-2 1,-4l0,-26.6l-3,0c-3,0 -5,0.4 -6,1.2c-1,0.4 -2,2.4 -2.4,5.4l-1.2,0l0,-8.6l0.2,0Z" style="fill-rule:nonzero;stroke:#000;stroke-width:1px;"/></svg>';

const SCALE_FACTOR = 4.166666666667;
const MOBILE_SCALE = 3.874;

const generateFilter = ({ red, green, blue }) => {
  return [1, 0, 0, 0, red, 0, 1, 0, 0, green, 0, 0, 1, 0, blue, 0, 0, 0, 1, 0];
};

export default class Customize extends React.Component {
  constructor(props) {
    super(props);
    this.canvas = null;
    this.state = {
      topObject: "text",
      zoomed: false
    };
  }
  componentDidMount() {
    const self = this;
    this.subscription = subscribe(value => {
      this.addItem(value);
    });
    setTimeout(() => {
      this.setState({
        zoomed: true
      });
    }, 1000);

    fabric.Image.filters.Brightness.fromObject =
      fabric.Image.filters.BaseFilter.fromObject;

    // Initialize Canvas
    this.canvas = new fabric.Canvas("canvas");
    this.canvas.setHeight(650);
    this.canvas.setWidth(430);
    if (this.props.jsonData) {
      this.canvas.loadFromJSON(this.props.jsonData);
    }
    this.canvas.on("selection:cleared", function() {
      self.deleteSvg.set({ opacity: 0 });
      //self.editSvg.setOpacity(0);
    });
    this.canvas.on("object:selected", function({ target }) {
      self.selected = self.canvas.getActiveObject();
      self.deleteSvg.set({ opacity: 1 });
      if (target.name === "text") {
        self.editSvg.set({ opacity: 1 });
      }
    });
    this.canvas.on("mouse:down", function(e) {
      if (e.target) {
        if (e.target.name === "delete") {
          if (self.deleteSvg.opacity === 0) {
            self.canvas.remove(self.selected);
          }
        }
        if (e.target.name === "edit") {
          if (self.editSvg.opacity === 0) {
            self.props.toggleTextPopover();
          }
        }
      }
    });
    this.canvas.on("object:rotating", function({ e, target }) {
      e.preventDefault();
      if (e.shiftKey) {
        target.angle = Math.round(target.angle / 45) * 45;
      }
    });
    this.deleteSvg = fabric.loadSVGFromString(deleteIcon, function(res) {
      self.deleteSvg = res[0];
      self.deleteSvg.selectable = false;
      self.deleteSvg.hasControls = false;
      self.deleteSvg.hasBorders = false;
      self.deleteSvg.hoverCursor = "pointer";
      self.deleteSvg.name = "delete";
      self.deleteSvg.top = 500;
      self.deleteSvg.left = 20;
      self.deleteSvg.opacity = 0;
      self.canvas.add(self.deleteSvg);
    });

    this.editSvg = fabric.loadSVGFromString(textString, function(res) {
      self.editSvg = res[0];
      self.editSvg.hasControls = false;
      self.editSvg.hasBorders = false;
      self.editSvg.hoverCursor = "pointer";
      self.editSvg.name = "edit";
      self.editSvg.top = 450;
      self.editSvg.left = 22;
      self.editSvg.opacity = 0;
      self.canvas.add(self.editSvg);
    });
  }
  updateIcons = target => {
    const { x, y } = target.calcCoords().tl;
    this.deleteSvg.left = x - 20;
    this.deleteSvg.top = y - 20;
    this.deleteSvg.bringToFront();
    if (target.name === "text") {
      const { x: ex, y: ey } = target.calcCoords().tr;
      this.editSvg.left = ex;
      this.editSvg.top = ey - 20;
    }
    //this.canvas.renderAll();
  };
  componentWillUnmount() {
    this.subscription && this.subscription();
  }
  addItem(item) {
    this.canvas.add(item);
  }
  _finalizeBottle = () => {
    const { cup, lid, cap, overmold } = this.props.color;
    this.canvas.clipTo = function(ctx) {
      ctx.rect(
        107 * SCALE_FACTOR,
        200 * SCALE_FACTOR,
        161 * SCALE_FACTOR,
        359 * SCALE_FACTOR
      );
    };
    this.deleteSvg.set({ opacity: 0 });
    this.editSvg.set({ opacity: 0 });
    this.canvas.renderAll();
    let img = this.canvas.toDataURL({
      format: "image/png",
      multiplier: SCALE_FACTOR
    });
    if (img.length === 6) {
      img = this.canvas.toDataURL({
        format: "image/png",
        multiplier: MOBILE_SCALE
      });
    }
    const svg = this.canvas.toSVG();
    const json = this.canvas.toJSON();
    this.canvas.clipTo = function(ctx) {
      ctx.rect(
        0,
        0,
        10000,
        10000
      );
    };
    const cupImage = new fabric.Image(document.getElementById("cup"), {
      left: 71,
      top: 160
    });
    const lidImage = new fabric.Image(document.getElementById("lid"), {
      left: 67,
      top: 39
    });
    const capImage = new fabric.Image(document.getElementById("cap"), {
      left: 66,
      top: 5
    });
    const overmoldImage = new fabric.Image(
      document.getElementById("overmold"),
      {
        left: 60,
        top: 0
      }
    );
    const cupFilter = new fabric.Image.filters.ColorMatrix({
      matrix: generateFilter(cup)
    });
    const lidFilter = new fabric.Image.filters.ColorMatrix({
      matrix: generateFilter(lid)
    });
    const capFilter = new fabric.Image.filters.ColorMatrix({
      matrix: generateFilter(cap)
    });
    const overmoldFilter = new fabric.Image.filters.ColorMatrix({
      matrix: generateFilter(overmold)
    });
    const canvas = new fabric.Canvas("preview");
    canvas.setHeight(650);
    canvas.setWidth(430);
    canvas.add(cupImage);
    canvas.add(lidImage);
    canvas.add(capImage);
    canvas.add(overmoldImage);
    cupImage.filters.push(cupFilter);
    lidImage.filters.push(lidFilter);
    capImage.filters.push(capFilter);
    overmoldImage.filters.push(overmoldFilter);
    cupImage.applyFilters(cupImage.filters);
    cupImage.sendToBack();
    lidImage.applyFilters(lidImage.filters);
    capImage.applyFilters(capImage.filters);
    overmoldImage.applyFilters(overmoldImage.filters);
    const imgElement = document.createElement("img");
    imgElement.onload = () => {
      const imgInstance = new fabric.Image(imgElement, {
        left: 0,
        top: 0,
      });
      imgInstance.scaleToHeight(650);
      imgInstance.scaleToWidth(430);
      canvas.add(imgInstance);
      const bottleImage = canvas.toDataURL({
        format: "image/png",
        multiplier: SCALE_FACTOR
      });
      this.props.finalizeBottle(img, bottleImage, svg, json);
    };
    imgElement.src = img;

    this.deleteSvg.set({ opacity: 1 });
    this.editSvg.set({ opacity: 1 });
  };
  render() {
    const { cup, cap, lid, overmold } = this.props.color;
    return (
      <div onKeyDown={this._keyPress}>
        <section className="section-heading row visible-md-block visible-lg-block visible-xl-block">
          CUSTOMIZE
        </section>
        <section className="row bottleContainer">
          <DesktopButtons
            {...this.props}
            finalizeBottle={this._finalizeBottle.bind(this)}
          />
          <div
            style={{
              transform:
                window.innerWidth <= 768 &&
                (this.state.zoomed
                  ? `translate(-47%, -83%) scale(1.4)`
                  : `translate(-50%, -50%) scale(${window.innerWidth /
                      window.innerHeight})`)
            }}
            className="col-sm-offset-1 customizeBottle col-sm-4"
          >
            <ImageFilter
              image={require("./bottles/cup.png")}
              filter={generateFilter(cup)}
              className="cup"
              style={{ width: "auto", display: "inline-block" }}
            />
            <ImageFilter
              image={require("./bottles/cap.png")}
              filter={generateFilter(cap)}
              className="cap"
              style={{ width: "auto", display: "inline-block" }}
            />
            <ImageFilter
              image={require("./bottles/lid.png")}
              filter={generateFilter(lid)}
              className="lid"
              style={{ width: "auto", display: "inline-block" }}
            />
            <ImageFilter
              image={require("./bottles/overmold.png")}
              filter={generateFilter(overmold)}
              className="overmold"
              style={{ width: "auto", display: "inline-block" }}
            />
            <img
            alt="cup"
              src={require("./bottles/cup.png")}
              filter={generateFilter(cup)}
              id="cup"
              style={{ display: "none" }}
            />
            <img
            alt="cap"
              src={require("./bottles/cap.png")}
              filter={generateFilter(cap)}
              id="cap"
              style={{ display: "none" }}
            />
            <img
            alt="lid"
              src={require("./bottles/lid.png")}
              filter={generateFilter(lid)}
              id="lid"
              style={{ display: "none" }}
            />
            <img
            alt="overmold"
              src={require("./bottles/overmold.png")}
              filter={generateFilter(overmold)}
              id="overmold"
              style={{ display: "none" }}
            />
            <canvas
              id="canvas"
              style={{ width: "100%", height: "100%", margin: 0, padding: 0 }}
            />
            <canvas id="preview" />
            <div className="customizeBottle-after" />
          </div>
          <div className="col-sm-3 visible-md-block visible-lg-block visible-xl-block">
            <h4>Restrictions:</h4>
            <p>
              Your design is limited to 4 colors. Every color you add will
              increase the unit cost.
            </p>
            <p>Gradients cannot be printed.</p>
            <p>
              Please use high resolution images in vector format. The designer
              currently only supports SVG vectors. You can convert AI and EPS
              format vectors to SVG using Adobe Illustrator or other popular
              vector editing programs.
            </p>
            <p>We are unable to print lines or shapes smaller than 0.3mm.</p>
            <br />
            <p>
              If you have any questions, please contact your sales rep or our{" "}
              <a href="mailto:sales@blenderbottle.com">Sales Team</a>
            </p>
          </div>
          <MobileButtons
            {...this.props}
            finalizeBottle={this._finalizeBottle.bind(this)}
          />
        </section>
      </div>
    );
  }
}

const DesktopButtons = props => (
  <div className="col-sm-3 buttonCol visible-md-block visible-lg-block visible-xl-block">
    <button onClick={props.toggleColorPopover}>
      CHOOSE COLOR <Arrows focus />
    </button>
    <button onClick={props.toggleLogoPopover}>
      UPLOAD LOGO <Arrows focus />
    </button>
    <button onClick={props.toggleTextPopover}>
      ADD TEXT <Arrows focus />
    </button>
    <button onClick={props.finalizeBottle} className="button-focus">
      FINALIZE <Arrows />
    </button>
  </div>
);

const MobileButtons = props => (
  <div className="mobileButtons visible-xs-block visible-sm-block">
    <div className="tabbar">
      <div onClick={props.toggleColorPopover}>
        <img alt="" src={require(`./img/color.svg`)} draggable={false} />
        COLOR
      </div>
      <div onClick={props.toggleLogoPopover}>
        <img alt="" src={require(`./img/logo.svg`)} draggable={false} />
        LOGO
      </div>
      <div onClick={props.toggleTextPopover}>
        <img alt="" src={require(`./img/text.svg`)} draggable={false} />
        TEXT
      </div>
    </div>
    <button onClick={props.finalizeBottle} className="button-focus">
      FINALIZE <Arrows />
    </button>
  </div>
);



// WEBPACK FOOTER //
// ./src/Customize.jsx